module.exports = __webpack_public_path__ + "img/56.1f2827a8.png";